import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import de from './de.json';
import pt from './pt.json';
import ja from './ja.json';
import zh from './zh.json';
import ko from './ko.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, es, fr, de, pt, ja, zh, ko },
  silentTranslationWarn: true,
});
